// extracted by mini-css-extract-plugin
module.exports = {"message":"z2kKT","inner":"QaJbK","title":"_0+iJI","text":"Jxuye","actions":"_756Hn","cancel":"XdIvY","confirm":"QT-if"};